import styled from "styled-components";
import { provideIsLoadingProp, } from "@/utils/context/LoadingContext";
export const CheckoutSectionHeadline = styled.h3.attrs(provideIsLoadingProp) `
  font-size: 1.125rem;
  font-weight: bold;
  margin: 0;
`;
